<style>
	.bg343 {
		background-color: #fff;width:100%; 
	}
 
 
.draw-enter-active, .draw-leave-active {
     transition: opacity 1s;
}
.draw-enter, .draw-leave-to /* .fade-leave-active below version 2.1.8 */ {
     opacity: 0;
}
.top_area{width:100%;height:4vw;position:fixed;top:1vw;left:0; }
.top_area img{display:block;float:left;height:4vw; }
.tabbar5{width:84vw;height:4vw;background:url(../../assets/images/tabbar_bg.png) center center; border-radius:.5vw;
float:left;margin-left:2.5vw;background-size:105% 105%; }
.tabbar5 span{display:block;float:left;line-height:4vw;font-size:1.4vw;}
.tabbar5 span.pos{  padding:0 1vw;}
.tabbar5 span.floder{ color:#666;}
 
.tabbar5 span.rights{background:url(../../assets/images/right.png) no-repeat;width:2vw;
height:4vw;background-position:center center;background-size:2vw;}

.interact_right{width:64vw;height: 45vw;background-color: #fffff9;margin: 0;padding: 0;overflow: hidden;margin-top:6vw;float: left;
border: #e3e3e3 solid 1px;box-sizing: border-box; border-left: 0;} 
.interact_right input.h_title{width: 60vw;margin: 0 auto;height: 5vw;display: block;border: 0;border-bottom: #ddd solid 1px;border-radius: 0;
font-size: 1.6vw;color: #3465ff;}
.interact_right input.h_title::placeholder{color: #3465ff;}
.interact_data_head{width: 60vw;height:5vw;border-bottom: #ddd solid 1px;}
.interact_data_head span{display: block;float: left;line-height: 5vw;font-size: 1.4vw;}
.interact_data_head span.m1{color: #999;}
.interact_data_head span.m2{color: #000;margin-left: 1vw;}
.interact_data_head span.m3{color: #c00;margin-left: 1vw;}
 
.charts_title span{display: block;height: 3vw;line-height: 3vw;border-bottom: #3465ff solid 1px; float: left;margin-left:2vw;}
.charts_div{width: 60vw;height: 35vw;margin:0 auto;padding: 0;overflow: hidden;}
.circles{width: 20vw;height: 35vw;float: left;}
.maps{width: 40vw;height: 35vw;float: right;}
</style>
<template>
	<div class="bg343">

         
	     <u_center></u_center>
	     <interact :main="main" :sub="sub" :title="title"></interact>
	     <div class="interact_right">
	     	 <div class="interact_data_head">
	     	 	<span class="m1">时间</span>
	     	 	<span class="m2">7天</span>
	     	 	<span class="m3">30天</span>
	     	 </div>
	     	  
	     	 <div class="charts_title"><span>信息阅读趋势图</span></div>
	     	 <div class="charts_div">
	     	 	<div class="circles">
	     	 		<div id="sex"  style="width: 100%; height: 100%"></div>
	     	 	</div>
	     	 	<div class="maps">
	     	 	    <div id="map" ref="mapOption" style="width: 100%; height: 100%"></div>
	     	     </div>
	     	 </div>
		 </div>

	</div>
</template>
<script>
import u_center from '@/components/u_center.vue'; 
import interact from '@/components/interact.vue'; 
import china from '../../../static/china3.json'




	export default {
	    components: {
		  u_center,
		  interact
	    },
		data() {
			return {
				token:"",
				main:5,
				sub:"1",
				title:"访问者数据",
				mapJson:"",
				mapData:"",
				mapOption:""
			}
		},
		mounted() {
		      var token= localStorage.getItem("token");
			  if(!token){
					 self.$router.push("/");  
			  }else{
			      self.token=token;
				  
			  } 
        
                this.drawLine()
                this.drawsec()
		},
		methods: {
		    drawsec(){
                    var myChartContainers = document.getElementById('sex');
                    var myChartChina = this.$echarts.init(myChartContainers)
                   // 绘制图表
			      var option = {
						  tooltip: {
						    trigger: 'item'
						  },
						  legend: {
						    top: '5%',
						    left: 'center'
						  },
						  series: [
						    {
						      name: 'Access From',
						      type: 'pie',
						      radius: ['40%', '70%'],
						      avoidLabelOverlap: false,
						      label: {
						        show: false,
						        position: 'center'
						      },
						      emphasis: {
						        label: {
						          show: true,
						          fontSize: '40',
						          fontWeight: 'bold'
						        }
						      },
						      labelLine: {
						        show: false
						      },
						      data: [
						        { value: 1048, name: '男性' },
						        { value: 735, name: '女性' }
						      ]
						    }
						  ]
						}
						myChartChina.setOption(option)
		    },
		    drawLine () {
                var myChartContainer = document.getElementById('map');
                 this.$echarts.registerMap('china', china)
		      var resizeMyChartContainer = function () {
		        myChartContainer.style.width = (document.body.offsetWidth / 2.5) + 'px'// 页面一半的大小
		        myChartContainer.style.height = (document.body.offsetHeight /1.5) + 'px'// 页面一半的大小
		        myChartContainer.style.marginleft = 0// 页面一半的大小
		        myChartContainer.style.top = 0// 页面一半的大小
		      }
		      resizeMyChartContainer()
		      var myChartChina = this.$echarts.init(myChartContainer)
 
		      function randomData () {
		        return Math.round(Math.random() * 500)
		      }
		      // 绘制图表
		      var optionMap = {
		        tooltip: {},
		        visualMap: {
	              min: 0,
	              max: 1500,
	              left: '10%',
	              top: 'bottom',
	              text: ['高','低'],
	              calculable : true,
	              color:['#0b50b9','#c3e2f4']
                  }, 
		        selectedMode: 'single',
		        series: [
		          {
		            name: '',
		            type: 'map',
		            mapType: 'china',
		            itemStyle: {
		              normal: {
		                borderColor: 'rgba(0, 0, 0, 0.2)'
		              },
		              emphasis: {
		                shadowOffsetX: 0,
		                shadowOffsetY: 0,
		                shadowBlur:  0,
		                borderWidth: 0,
		                shadowColor: 'rgba(0, 0, 0, 0.5)'
		              }
		            },
		            showLegendSymbol: false,
		            label: {
		              normal: {
		                show: true
		              },
		              emphasis: {
		                show: false
		              }
		            },
		            data: [
		              { name: '北京', value: randomData() },
		              { name: '天津', value: randomData() },
		              { name: '上海', value: randomData() },
		              { name: '重庆', value: randomData() },
		              { name: '河北', value: randomData() },
		              { name: '河南', value: randomData() },
		              { name: '云南', value: randomData() },
		              { name: '辽宁', value: randomData() },
		              { name: '黑龙江', value: randomData() },
		              { name: '湖南', value: randomData() },
		              { name: '安徽', value: randomData() },
		              { name: '山东', value: randomData() },
		              { name: '新疆', value: randomData() },
		              { name: '江苏', value: randomData() },
		              { name: '浙江', value: randomData() },
		              { name: '江西', value: randomData() },
		              { name: '湖北', value: randomData() },
		              { name: '广西', value: randomData() },
		              { name: '甘肃', value: randomData() },
		              { name: '山西', value: randomData() },
		              { name: '内蒙古', value: randomData() },
		              { name: '陕西', value: randomData() },
		              { name: '吉林', value: randomData() },
		              { name: '福建', value: randomData() },
		              { name: '贵州', value: randomData() },
		              { name: '广东', value: randomData() },
		              { name: '青海', value: randomData() },
		              { name: '西藏', value: randomData() },
		              { name: '四川', value: randomData() },
		              { name: '宁夏', value: randomData() },
		              { name: '海南', value: randomData() },
		              { name: '台湾', value: randomData() },
		              { name: '香港', value: randomData() },
		              { name: '澳门', value: randomData() }
		            ]
		          }
		        ]
		      }

		                myChartChina.setOption(optionMap)
				      window.onresize = function () {
				        resizeMyChartContainer()
				        myChartChina.resize()
				      }
		   },
			vote_add(){
                   this.$router.push("/vote_add");  
			},
			 add_template(){	 
              if(!this.sign_selected){
              	  this.$toast.center('请选择签名');
              	  return;
              }
		      let self=this;
			  self.$loading('提交中...');
		      axios.post(this.$api+'/message/add_template', {
					   token:self.token,
					   type:self.type,
					   content:self.content,
					   signname:self.signname
		      }).then(function (response) {  
			      let data=response.data;
				  if(data.state==1){
				             self.$toast.center('添加成功，请等待审核');	
                             setTimeout(function(){
								        self.$loading.close();
										self.back();
					         },1000);				  
					 		 
				  }else if(data.state==3){                
					 self.$router.push("/");  		 
				  }else{
				     self.$loading.close();
				     self.$toast.center(data.msg);	
				  } 
		      }).catch(function (error) {
			         
		      });
		} 
	}
}
</script>


// WEBPACK FOOTER //
// src/pages/interact/visit.vue